import { TurnResources } from '@/types/turn-api';
import { TurnResourcesEnum } from '@/types/turn-enums';
import { DataProviderResource } from './types';

export const LOGIN_URL = '/login';
export const UNAUTHORIZED = 401;

export const methodMap: Record<string, string> = {
  UPDATE: 'PUT',
  CREATE: 'POST',
  PATCH: 'PATCH',
};

export const REFERENCE_TO_RESOURCE: Record<DataProviderResource, TurnResources> = {
  adverse: TurnResourcesEnum.FcraWorkersAdverse,
  candidates: TurnResourcesEnum.FcraWorkers,
  cm_criminal: TurnResourcesEnum.MonitoringCriminal,
  criminal_records: TurnResourcesEnum.FcraWorkersCountyCriminalRecords,
};
